import { Image } from '@common-fe/common-fe';
import styled from 'styled-components';

export const ProportionalImage = styled(Image)`
  object-fit: contain;
`;
